import { render } from "./PurchaseGuidePage.vue?vue&type=template&id=102a1ff6"
import script from "./PurchaseGuidePage.vue?vue&type=script&lang=js"
export * from "./PurchaseGuidePage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pavithram.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__